module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Share.9cf9394e.svg";